import { useAuthContext } from '~/hooks/useAuthContext'

import { AccountInfo } from './AccountInfo'
import { ConnectedAccounts } from './ConnectedAccounts'
import { ConnectedRoninWallet } from './ConnectedRoninWallet'
import { EmailSignIn } from './EmailSignIn'
import { Notice2FA } from './Notice2FA'
import { NoticeConnectWallet } from './NoticeRoninWallet'
import { QRCode } from './QRCode'

export const Layout: React.FC = () => {
  const { mfaMethods, user, userV2 } = useAuthContext()

  const roninAddress = userV2?.account?.wallet?.secondary
  const mpcAddress = userV2?.account?.wallet?.identity

  const isShowNoticeMFA = mfaMethods && !mfaMethods?.find(item => item.active)
  return (
    <div className="flex flex-col gap-24">
      {(() => {
        if (!user || !mfaMethods) {
          return <></>
        }
        if (!roninAddress && !mpcAddress) return <NoticeConnectWallet />

        if (roninAddress && isShowNoticeMFA) return <Notice2FA />

        return <></>
      })()}
      <AccountInfo />
      <ConnectedRoninWallet />
      <EmailSignIn />
      <ConnectedAccounts />
      <QRCode />
    </div>
  )
}
